import axios from 'axios';
import * as AxiosLogger from 'axios-logger';
import {setGlobalConfig} from 'axios-logger';
import {logout} from '../core/utils/routing.util';
setGlobalConfig({
  prefixText: 'http-client',
  dateFormat: 'HH:MM:ss',
  status: true,
  headers: false,
});

const instance = axios.create();

instance.interceptors.request.use(
  AxiosLogger.requestLogger,
  AxiosLogger.errorLogger,
);

instance.interceptors.response.use(AxiosLogger.responseLogger, err => {
  if (err.response.status === 401 || err.response.status === 403) {
    logout();
  } else {
    console.log('DDDD--0');
  }
});

export default instance;
